import EDPInfo from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPInfo';
import { withEDPInfoProps } from 'viewModel/happening/withEDPInfoProps';

export default withEDPInfoProps(EDPInfo);
